import { getPricePerTicket } from './helpers/get-price-per-ticket'
import { Button } from '@components/gassan-ui'
import { Heading } from '@components/gassan-ui/Typography/Heading'
import { formatPrice } from '@lib/formatPrice'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { cn } from '@lib/cn'

type TourDetailFareHarborCTAProps = {
  ctaUrl?: string
  tourTitle: string
  codename: string
}

export const TourDetailFareHarborCTA: FC<TourDetailFareHarborCTAProps> = ({
  ctaUrl,
  tourTitle,
  codename,
}) => {
  const { t } = useTranslation('other')
  const pricePerTicket = getPricePerTicket(codename)
  const displayPrice = pricePerTicket > 0 ? formatPrice(pricePerTicket) : t('free')
  const ctaLabel = `${t('bookTour')} - ${displayPrice}`

  if (!ctaUrl) {
    return null
  }

  return (
    <section
      className={cn(
        'mb-10 flex flex-col items-center justify-center gap-4 bg-pampasLight px-6 py-4',
        'sm:flex-row sm:justify-between',
        'lg:mb-14 lg:px-10 lg:py-8',
        'xl:mb-20 xl:px-14 xl:py-10',
      )}
    >
      <div>
        <Heading variant="h2" as="h2" className="mb-2">
          {t('bookThisTour')}
        </Heading>
        <Heading variant="h4" as="h3" className="mb-0 text-shade-500">
          {tourTitle}
        </Heading>
      </div>
      <Button variant="dark" as="link" href={ctaUrl}>
        {ctaLabel}
      </Button>
    </section>
  )
}
